import type { AuditLog, SecurityEvent } from './types';

export const auditLogFixtures: readonly AuditLog[] = [
  Object.freeze({
    id: 'audit-log-1',
    occurredAt: '2026-07-20T02:00:00Z',
    principalActorId: 'admin-a',
    principalRole: 'SUPER_ADMIN',
    serviceActorId: 'service-backoffice',
    partnerId: 'partner-a',
    agentId: null,
    requestId: 'req-uuid-audit-1',
    publicRequestId: 'req-audit-1',
    correlationId: null,
    action: 'PARTNER_STATUS_CHANGE',
    entityType: 'PARTNER',
    entityId: 'partner-a',
    reason: 'Suspended pending compliance review',
    before: { status: 'ACTIVE' },
    after: { status: 'SUSPENDED' },
    metadata: { channel: 'backoffice-console' },
    sourceIp: '203.0.113.10',
  }),
  Object.freeze({
    id: 'audit-log-2',
    occurredAt: '2026-07-21T04:00:00Z',
    principalActorId: 'admin-b',
    principalRole: 'AGENT_ADMIN_USER',
    serviceActorId: 'service-backoffice',
    partnerId: 'partner-b',
    agentId: 'agent-b',
    requestId: 'req-uuid-audit-2',
    publicRequestId: 'req-audit-2',
    correlationId: null,
    action: 'AGENT_CREATED',
    entityType: 'AGENT',
    entityId: 'agent-b',
    reason: null,
    before: null,
    after: { code: 'AGENT-B', status: 'ACTIVE' },
    metadata: {},
    sourceIp: '203.0.113.20',
  }),
] as const;

export const securityEventFixtures: readonly SecurityEvent[] = [
  Object.freeze({
    id: 'security-event-1',
    occurredAt: '2026-07-20T05:00:00Z',
    category: 'AUTHENTICATION',
    severity: 'HIGH',
    principalActorId: 'admin-a',
    principalRole: 'SUPER_ADMIN',
    serviceActorId: 'service-backoffice',
    partnerId: null,
    agentId: null,
    credentialActorId: 'credential-a',
    requestId: 'req-uuid-security-1',
    publicRequestId: 'req-security-1',
    sourceIp: '203.0.113.11',
    eventCode: 'LOGIN_FAILED',
    details: { attempts: 3 },
  }),
  Object.freeze({
    id: 'security-event-2',
    occurredAt: '2026-07-22T06:00:00Z',
    category: 'AUTHORIZATION',
    severity: 'CRITICAL',
    principalActorId: 'admin-b',
    principalRole: 'AGENT_ADMIN_USER',
    serviceActorId: 'service-backoffice',
    partnerId: 'partner-a',
    agentId: null,
    credentialActorId: null,
    requestId: 'req-uuid-security-2',
    publicRequestId: 'req-security-2',
    sourceIp: '203.0.113.21',
    eventCode: 'PERMISSION_DENIED',
    details: { resource: 'partner-credit' },
  }),
] as const;
